import { Controller } from "@hotwired/stimulus";
import consumer from "../../channels/consumer";

/**
 * 画像を保存した時に、出品可能な画像登録がある場合は編集内容を保存するボタンを活性化する
 */
export default class extends Controller {
  static values = { exhibitedCarId: Number };
  static targets = ["save", "disabledSave"];

  connect() {
    this.channel = consumer.subscriptions.create(
      {
        channel: "ListingCarImageChannel",
        exhibited_car_id: this.exhibitedCarIdValue,
      },
      {
        received: this.#received,
      },
    );
  }

  disconnect() {
    if (this.channel) {
      consumer.subscriptions.remove(this.channel);
      this.channel = null;
    }
  }

  #received = (data) => {
    if (Object.hasOwn(data, "is_enough_images")) {
      if (data.is_enough_images) {
        this.saveTarget.classList.remove("d-none");
        this.disabledSaveTarget.classList.add("d-none");
      } else {
        this.saveTarget.classList.add("d-none");
        this.disabledSaveTarget.classList.remove("d-none");
      }
    }
  };
}
